/**
 * แปลงค่า affiliate ที่ติดมากับ URL ให้เป็น customer_id ที่ backend รับได้
 *
 * ---------------------------------------------------------------------------
 * ทำไมต้องมีไฟล์นี้
 *
 * ตอนนี้มีลิงก์ชวน 2 แบบวิ่งอยู่พร้อมกัน และหน้าตาไม่เหมือนกัน:
 *
 *   ระบบ affiliate เดิม   ?affiliate=126          ← ตัวเลขล้วน
 *                          สร้างจาก backend-agent-player
 *                          (affiliate_controller.go: LinkWeb)
 *
 *   ระบบ partner ใหม่     ?affiliate=711aa126     ← มี code ของเว็บนำหน้า
 *                          สร้างจาก backend-partner-backoffice
 *
 * ฝั่ง backend รับ affiliate เป็น int (parameters/request_auth.go)
 * ถ้าส่ง "711aa126" ไปตรง ๆ gin จะ bind ไม่ผ่านและคืน error ทั้ง request
 * ผู้ใช้จะ "สมัครไม่ได้เลย" ไม่ใช่แค่ไม่ถูกผูกเข้าสายงาน
 *
 * ---------------------------------------------------------------------------
 * ทำไมไม่ตัด prefix ด้วย slice() เฉย ๆ
 *
 * hero-fontend-player ทำแบบนั้นได้ (@utility/app/encrypt.js) เพราะลิงก์ทุกอัน
 * ของเว็บนั้นมี prefix เสมอ — มันสร้างลิงก์เอง ไม่ได้ใช้ link_web จาก backend
 *
 * แต่เว็บนี้ใช้ link_web จาก backend ซึ่งเป็นตัวเลขล้วน การ slice() ทื่อ ๆ จะ
 * ทำให้ลิงก์เก่าพังแบบเงียบ ๆ:
 *
 *   "126"       -> ""      ไม่ผูกใครเลย
 *   "12345678"  -> "678"   ผูกผิดคน  ← อันตรายที่สุด ไม่มี error ให้เห็น
 *
 * จึงตัด prefix เฉพาะเมื่อ "ขึ้นต้นด้วย prefix จริง และส่วนที่เหลือเป็นตัวเลข
 * ล้วน" เท่านั้น กรณีอื่นถือว่าเป็นลิงก์เก่าหรืออ่านไม่ออก
 *
 * ---------------------------------------------------------------------------
 * ค่าที่อ่านไม่ออกคืนค่าว่าง ไม่ใช่เดา
 *
 * เช่น prefix ของเว็บอื่น ("711ab126" บนเว็บที่ code เป็น 711aa) แปลว่าลิงก์นั้น
 * ถูกสร้างมาสำหรับอีกเว็บหนึ่ง customer_id คนละชุดกัน การตัด prefix แล้วใช้เลข
 * ที่เหลือคือการผูกคนเข้าสายของคนที่ไม่มีอยู่จริงบนเว็บนี้ หรือแย่กว่านั้นคือ
 * ผูกเข้าสายของคนอื่นที่บังเอิญมี id ตรงกัน
 */

const PREFIX = process.env.REACT_APP_DEFAULT_AGENT_CODE;

/** ตัวเลขล้วนอย่างน้อย 1 หลัก */
const DIGITS_ONLY = /^[0-9]+$/;

export function normalizeAffiliate(raw) {
  if (raw === null || raw === undefined) return "";

  const value = String(raw).trim();
  if (value === "") return "";

  // ลิงก์เก่า: ตัวเลขล้วนอยู่แล้ว ส่งต่อได้เลย ห้ามแตะ
  if (DIGITS_ONLY.test(value)) return value;

  // ลิงก์ partner: <code ของเว็บ><customer_id>
  // เทียบแบบไม่สนตัวพิมพ์ เพราะ agent.code ใน DB เก็บเป็นตัวพิมพ์ใหญ่ (711AB)
  // แต่ REACT_APP_DEFAULT_AGENT_CODE ตั้งเป็นตัวพิมพ์เล็ก (711aa)
  const prefix = String(PREFIX || "").toLowerCase();

  if (prefix && value.toLowerCase().startsWith(prefix)) {
    const rest = value.slice(prefix.length);

    if (DIGITS_ONLY.test(rest)) return rest;
  }

  // อ่านไม่ออก — ไม่ผูกใครดีกว่าผูกมั่ว
  return "";
}

export default normalizeAffiliate;
